module.exports = __webpack_public_path__ + "static/media/logoImpulseGreenColor.b082188a.png";